import Queue from 'promise-queue';

export default class AccessQueue {
  static getQueue() {
    if (typeof this.queue === 'undefined') {
      Queue.configure(window.Promise);
      this.queue = new Queue(1, 100);
    }
    return this.queue;
  }

  static getCacheQueue() {
    if (typeof this.cacheQueue === 'undefined') {
      Queue.configure(window.Promise);
      this.cacheQueue = new Queue(1, 100);
    }
    return this.cacheQueue;
  }
}
